import React, { MouseEventHandler } from 'react';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { colors } from 'spw-theme';

type Option = {
  activeCondition: () => boolean;
  onClick: MouseEventHandler;
  text: string;
  dataTestId?: string;
};

type Props = {
  options: Option[];
  buttonClassName?: string;
};

const useStyles = makeStyles({
  button: {
    border: `1px solid ${colors.veryLightGray}`,
    borderRadius: '4px',
    color: colors.black,
    fontWeight: 400,
    height: '28px',
    padding: '4px 12px',
    textTransform: 'none',
    fontSize: 14,

    '&:not(:last-child)': {
      marginRight: '8px',
    },

    '&.active': {
      backgroundColor: colors.backgroundGrey,
      fontWeight: 500,
      padding: '4px 11px',
    },

    '&.main-green-active.active': {
      backgroundColor: colors.mainGreen,
      color: colors.white,
    },
  },
});

const ButtonGroup = ({ options, buttonClassName }: Props) => {
  const classes = useStyles();

  return (
    <div>
      {options.map(({ activeCondition, onClick, text, dataTestId }) => (
        <Button
          key={text}
          onClick={onClick}
          className={`${classes.button} ${buttonClassName || ''} ${
            activeCondition() ? 'active' : ''
          }`}
          data-testid={dataTestId}
        >
          {text}
        </Button>
      ))}
    </div>
  );
};

export default ButtonGroup;
